const DEFAULT_REFRESH_SKEW_SECONDS = 90;

export const getTokenPayload = token => {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const [, payload] = token.split('.');
  if (!payload) {
    return null;
  }

  try {
    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
    const paddedPayload = normalizedPayload.padEnd(
      normalizedPayload.length + ((4 - (normalizedPayload.length % 4)) % 4),
      '=',
    );
    return JSON.parse(window.atob(paddedPayload));
  } catch (e) {
    return null;
  }
};

export const getTokenExpirationMs = token => {
  const payload = getTokenPayload(token);
  const exp = Number(payload?.exp);
  return Number.isFinite(exp) ? exp * 1000 : 0;
};

export const shouldRefreshToken = (token, skewSeconds = DEFAULT_REFRESH_SKEW_SECONDS) => {
  const expirationMs = getTokenExpirationMs(token);
  if (!expirationMs) {
    return false;
  }

  return expirationMs - Date.now() <= Number(skewSeconds) * 1000;
};
